import { NgModule } from "@angular/core";
import { SafePipe } from "./safe-url.pipe";
import { ThumbPipe } from "./thumb.pipe";

@NgModule({
    declarations: [
        SafePipe,
        ThumbPipe
    ],
    exports: [
        SafePipe,
        ThumbPipe
    ]
})
export class PipesModule { }